import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TokenControlService } from "../../services/state/tokenControl.service";
import { WelcomeService } from "../../services/welcome/welcome.service";
import { CONFIG } from '../../constants/constants';
declare var $: any;

@Component({
  selector: 'app-security',
  templateUrl: './security.component.html',
  styleUrls: ['./security.component.css']
})
export class SecurityComponent implements OnInit {

  url: string;
  urlSafe: SafeResourceUrl;
  
  constructor(private _tokenController: TokenControlService,
    private _welcomeDataService: WelcomeService, 
    public sanitizer: DomSanitizer) { }

    ngOnInit() {

      this.url = CONFIG.URL_PROCTORING+"?matricula="+this._tokenController.token.credentialId
                   +"&examen="+this._welcomeDataService.data.idTerritorium
                   +"&appKey="+CONFIG.APP_KEY;

      this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    }

}